import * as Api from '../api/tools';
import { pendingTask, begin, end, endAll } from 'react-redux-spinner';
import constants from '../constants'
import { bindActionCreators } from 'redux';
import { updateDoorPreview } from './door_preview'
import { setDefaultOrderState, validateStep } from './order_actions'
import _ from 'lodash'

export const fetchConstructionsSuccess = (offers) => ({
  type: constants.ACTIONS.FETCH_CONSTRUCTIONS_SUCCESS,
  [pendingTask]: end,
  payload: offers
});

export const fetchConstructionsStart = () => {
  return {
    type: constants.ACTIONS.FETCH_CONSTRUCTIONS_START,
    [pendingTask]: begin
  };
};

export const fetchConstructionPartsSuccess = (groups) => ({
  type: constants.ACTIONS.FETCH_CONSTRUCTION_PARTS_SUCCESS,
  [pendingTask]: end,
  payload: groups
});

export const fetchConstructionPartsStart = () => {
  return {
    type: constants.ACTIONS.FETCH_CONSTRUCTION_PARTS_START,
    [pendingTask]: begin
  };
};

export const setSelectedConstructionTypeSuccess = (id) => (dispatch, getState) => {
  let
    { constructionsState } = getState(),
    construction = _.find(constructionsState.collection, item => item.id == id);
  dispatch({
    type: constants.ACTIONS.CONSTRUCTION_TYPE_SELECTED,
    payload: {selected_type_id: id, selected_type: construction}
  });
};


export const showPopup = (item) => (dispatch, getState) => {
  dispatch({
    type: constants.ACTIONS.SHOW_POPUP,
    payload: {item: item}
  });
};

export const hidePopup = () => (dispatch, getState) => {
  dispatch({
    type: constants.ACTIONS.HIDE_POPUP,
  });
};

export const fetchConstructions = (params) => (dispatch, getState) => {
  dispatch(fetchConstructionsStart());
  return Api.ajax({
    url: constants.API.ROUTES.CONSTRUCTIONS_PATH,
    method: 'GET',
    params: params
  }).then(response => {
    let item_id = _.get(response.data, '[0].id');
    dispatch(fetchConstructionsSuccess({
      collection: response.data || [],
    }));
    if (item_id) {
      bindActionCreators(setSelectedConstructionTypeSuccess, dispatch)(item_id);
      bindActionCreators(validateStep, dispatch)();
      bindActionCreators(updateDoorPreview, dispatch)(getState());
      bindActionCreators(fetchConstructionsParts, dispatch)({id: item_id});
    }
  })
  .catch(error => {
    throw(error);
  });
};

export const fetchConstructionsParts = (params) => (dispatch, getState) => {
  dispatch(fetchConstructionPartsStart());
  return Api.ajax({
    url: constants.API.ROUTES.CONSTRUCTION_PATH,
    method: 'GET',
    params: params
  }).then(response => {
    dispatch(fetchConstructionPartsSuccess(response.data.groups || {}));
  })
  .catch(error => {
    throw(error);
  });
};

export const setSelectedConstructionType = (id) => (dispatch, getState) => {
  dispatch(setSelectedConstructionTypeSuccess(id));
  bindActionCreators(fetchConstructionsParts, dispatch)({id: id});
  bindActionCreators(setDefaultOrderState , dispatch)();
};



// WEBPACK FOOTER //
// ./app/javascript/app/actions/constructions_actions.js